import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  let options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/imports?includes=organization,morphedModels`, options)
    .then((response) => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta,
      };
    });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/imports/${id}?include=organization,importedItems,linkedObject`,
      options
    )
    .then((response) => jsona.deserialize(response.data));
}

function models() {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.get(`${url}/imports/models`, options).then((response) => {
    jsona.deserialize(response.data);
    return response.data?.data;
  });
}

function add(data) {
  const payload = jsona.serialize({
    stuff: data,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/imports?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(data) {
  const payload = jsona.serialize({
    stuff: data,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/imports/${data.id}?includes=organization`, payload, options)
    .then((response) => jsona.deserialize(response.data));
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return axios.delete(`${url}/imports/${id}`, options);
}

function runDry(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/imports/${id}/run-dry`, options)
    .then((response) => jsona.deserialize(response.data));
}
function runProductSynchronization(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/imports/${id}/product-synchronize`, options)
    .then((response) => jsona.deserialize(response.data));
}
function runDryProductSynchronization(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/imports/${id}/product-dry-synchronize`, options)
    .then((response) => jsona.deserialize(response.data));
}

function run(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/imports/${id}/run`, options)
    .then((response) => jsona.deserialize(response.data));
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  models,
  runDry,
  run,
  runProductSynchronization,
  runDryProductSynchronization,
};
